export default "__VITE_ASSET__Gz2e2BnJ__"